import React, { useState } from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { BiMinusCircle } from 'react-icons/bi';
import './accordion.css';
import PropTypes from 'prop-types';

const Accordion = ({ content, title, section, isResto }) => {
  const [isActive, setIsActive] = useState(false);
  const Component = content;
  return (
    <div className="accordion-item">
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div>{title}</div>
        <div className="iconsContainer">
          {isActive ? <BiMinusCircle /> : <AiOutlinePlusCircle />}
        </div>
      </div>
      {isActive && (
        <div className="accordion-content">
          <Component section={section} isResto={isResto} />
        </div>
      )}
    </div>
  );
};
Accordion.propTypes = {
  content: PropTypes.any,
  section: PropTypes.any,
  title: PropTypes.string,
  isResto: PropTypes.bool,
};

export default Accordion;
